/**
 * List-page state that lives in the URL (Corbin, 2026-10-20: going into an operator and back lost
 * the "devon" search and the filters). The helpers moved to web-shared for every web app
 * (OPEN-191 / OPEN-204); this binds them to web-admin's router, so imports stay as they were.
 *
 * Each filter is a query parameter, so browser back, a refresh and a shared link all restore the
 * list exactly. A list row opens its detail page with `listFrom(location)` as router state; the
 * detail page's own "Back" goes to `useBackTo(<list path>)`. See web-shared `lib/url-state.ts`.
 */

import { useLocation, useSearchParams } from 'react-router-dom';
import { createUrlState } from '@lodex-pro/web-shared';

export {
  ariaSort,
  listFrom,
  sortRows,
  type ListFromState,
  type SortState,
} from '@lodex-pro/web-shared';

export const { useUrlParam, useUrlFlag, useUrlNumber, useBackTo, useUrlSort } = createUrlState({
  useSearchParams,
  useLocation,
});
